import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';
import { toast } from 'react-toastify';

const ActivitySettingsForm = ({
  headerGroup,
  handleCreateItem
}) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');

  const handleSubmit = useCallback(async () => {
    if (!name.trim()) {
      return toast.error('Activity name is required', {
        position: toast.POSITION.BOTTOM_CENTER
      });
    }

    const res = await handleCreateItem({ name: name.trim(), description: description.trim() });

    if (res) {
      setName('');
      setDescription('');
    }
  }, [name, description, handleCreateItem]);

  return (
    <tr {...headerGroup.getHeaderGroupProps()} className="add-activity-row">
      <th style={{ flex: '110 0 auto', width: 110 }}>
        <input
          type="text"
          className="the-field"
          placeholder="Activity name"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </th>
      <th style={{ flex: '150 0 auto', width: 150 }}>
        <input
          type="text"
          className="the-field"
          placeholder="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
        />
      </th>
      <th style={{ flex: '100 0 auto', width: 100 }} />
      <th style={{ flex: '80 0 auto', width: 80 }}>
        <button className="btn btn-sm btn-primary" onClick={handleSubmit}>
          Add
        </button>
      </th>
    </tr>
  );
};

ActivitySettingsForm.propTypes = {
  headerGroup: PropTypes.object.isRequired,
  handleCreateItem: PropTypes.func.isRequired
};

export default ActivitySettingsForm;
